import React from 'react';
import UnderwritingSingleTenant from '../UnderwritingSingleTenant';
import UnderwritingMultiTenant from '../UnderwritingMultiTenant';
import {convertPhoneNumber} from "../../utils";
import request from "arcdynamic-request";
import {AGENTS} from '../../consts/tables';
import Alert from "../Alert";

const cloneDeep = require('lodash.clonedeep');

export default class Financials extends React.Component {
    constructor(props) {
        super(props);
        this.state = {
            data: {},
            newData: props.data,
            agents: [],
            agentIsCurrentUser: false,
            error: null,
            success: null,
        };
        this.handleChange = this.handleChange.bind(this);
        this.close = this.close.bind(this);
        this.setDataFromChild = this.setDataFromChild.bind(this);
        document.body.overflow = 'hidden';
    }


    static equals(agents, agentIds) {
        return agents.length === agentIds.length && agents.map((value, index) => value.id === agentIds[index]);
    }

    async componentDidMount() {
        const agents = this.state.agents;
        const teamAgentsIds = [this.props.data.LISTING_AGENT_1, this.props.data.LISTING_AGENT_2, this.props.data.LISTING_AGENT_3]
            .filter(id => id !== null && id !== undefined);
        const agentId = this.props.data.LISTING_AGENT_4;

        if (!agents.length) {
            const agentsIds = agentId ? [agentId] : teamAgentsIds;
            const tableName = agentId ? AGENTS : 'TEAM';
            let agentIsCurrentUser = false;

            if (agentsIds && agentsIds.length && !Financials.equals(agents, agentsIds)) {
                await Promise.all(agentsIds.map(async id => {
                    const agentData = await this.getAgent(id, tableName);
                    if (agentData) {
                        const agent = {
                            id: id,
                            name: `${agentData.FIRST_NAME} ${agentData.LAST_NAME}`,
                            phone: convertPhoneNumber(agentData.PHONE),
                            email: agentData.EMAIL || '',
                        };
                        agents.push(agent);

                        if (tableName === 'TEAM' && agent.email === this.props.email) {
                            agentIsCurrentUser = true;
                        }
                    }
                }));

                this.setState({agents, agentIsCurrentUser});
            }
        }
    }

    async getAgent(id, tableName) {
        const res = await request(arc.path.api, {
            service: 'arcimedes',
            action: 'open.datasource.table.Data.getData',
            params: ['code', tableName, {
                filter: [{
                    'text': id,
                    'code': 'ARCIMEDES_ROW_ID',
                    'type': 'exact',
                }],
            }]
        });
        if (res && res.success && Array.isArray(res.data) && res.data.length) {
            return res.data[0];
        }
    }

    handleChange(e) {
        this.setData(e.currentTarget.name, e.currentTarget.value);
    }

    setData(key, value) {
        const data = {...cloneDeep(this.state.data), [key]: value};
        this.setState({data});
    }

    close() {
        this.props.close(true);
    }

    setDataFromChild({error = false, newData, savedTenants, newTenants, success}) {
        if (error) {
            this.setState({error}, () => {
                setTimeout(() => {
                    this.setState({error: null});
                }, 3000)
            });
            return;
        }
        const state = {
            success,
        };
        if (newData)
            state.newData = newData;
        this.setState(state, () => {
            setTimeout(() => {
                this.setState({success: null});
            }, 3000)
        });
        this.props.parentSetData({newData, savedTenants, newTenants});
    }
    
    componentWillUnmount() {
        document.body.overflow = 'auto';
    }

    render() {
        const data = this.state.newData;
        const {agents, agentIsCurrentUser, error, success} = this.state;
        const isAgent = this.props.isAgent;
        const isSuper = this.props.isSuper;

        return (
            <div className='Financials' lang='en-US' id="visible-print">
                {['STNL', 'Other'].includes(data.TYPE) ?
                    <UnderwritingSingleTenant loation={this.props.location} data={data} parentSetData={this.setDataFromChild} isAgent={isAgent} isSuper={isSuper} agents={agents} agentIsCurrentUser={agentIsCurrentUser}/>
                    :
                    <UnderwritingMultiTenant data={data} allTenantsById={this.props.allTenantsById} parentSetData={this.setDataFromChild} isAgent={isAgent} isSuper={isSuper} agents={agents} agentIsCurrentUser={agentIsCurrentUser}/>
                }
                {success ? <Alert type='success'>{success}</Alert> : null}
                {error ? <Alert type='error'>{error}</Alert> : null}
                <div className="close-financials" onClick={this.close}/>
                <img src={arc.path.media+'stnl-background.png'} style={{visibility: 'hidden', position: 'absolute', width: 0, height: 0}}/>
            </div>
        );
    }
}